export default "__VITE_ASSET__BDALtF30__"